import { useHistory, Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Capacitor } from "@capacitor/core";

import FunctionCard from "../../components/FunctionCard";

import { useReportDispatch, selectFunction } from "../../state";
import { LitterFunction } from "custom/litterFunctions";
import { linkToReportItemsList } from "routes/report/links";
import { linkToGeotag } from "routes/photo/routes/geotag/links";
import config from "custom/config";
import {
  usePhotoPageState,
  usePhotoPageDispatch,
  setMetaData
} from "pages/photo/state";
import {
  isImageMetaState,
  isBrowserImageState,
  isCordovaImageState
} from "pages/photo/state/types";
import { useGPSLocation } from "providers/LocationProvider";
import useEffectOnMount from "hooks/useEffectOnMount";
import loadPhoto from "pages/photo/pages/CategorisePhotoPage/utils";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box"
  },
  imageContainer: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    alignSelf: "center"
  },
  caption: {
    paddingInline: theme.spacing(2),
    paddingTop: theme.spacing(2)
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1),
    padding: theme.spacing(2)
  }
}));

export default function FunctionSelectPage() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useReportDispatch();
  const photoDispatch = usePhotoPageDispatch();
  const state = usePhotoPageState();
  const gpsLocation = useGPSLocation();

  useEffectOnMount(() => {
    if (isImageMetaState(state)) {
      // already loaded
    } else if (isCordovaImageState(state)) {
      const { file, fromCamera } = state;
      loadPhoto({
        fileOrFileName: Capacitor.convertFileSrc(file.filename),
        fromCamera,
        gpsLocation,
        cordovaMetadata: file.json_metadata
          ? JSON.parse(file.json_metadata)
          : null,
        callback: (metadata) => photoDispatch(setMetaData(metadata))
      });
    } else if (isBrowserImageState(state)) {
      const { file, fromCamera } = state;
      loadPhoto({
        fileOrFileName: file,
        fromCamera,
        gpsLocation,
        callback: (metadata) => photoDispatch(setMetaData(metadata))
      });
    }
  });

  if (
    isImageMetaState(state) &&
    (!state.imgLocation ||
      (state.imgLocation.latitude === config.CENTER[1] &&
        state.imgLocation.longitude === config.CENTER[0]))
  ) {
    return <Redirect to={linkToGeotag()} />;
  }

  const handleSelect = (fn: LitterFunction) => {
    dispatch(selectFunction(fn));
    history.push(linkToReportItemsList(fn));
  };

  const functions = [
    LitterFunction.FOOD_DRINK,
    LitterFunction.PERSONAL_CARE,
    LitterFunction.SMOKING,
    LitterFunction.OTHER
  ];

  return (
    <div className={classes.wrapper}>
      <div className={classes.imageContainer}>
        <img
          src={isImageMetaState(state) ? state.imgSrc : ""}
          className={classes.img}
          alt=""
        />
      </div>
      <div className={classes.caption}>Choose a category to add items</div>
      <div className={classes.grid}>
        {functions.map((fn) => (
          <FunctionCard key={fn} fn={fn} onClick={() => handleSelect(fn)} />
        ))}
      </div>
    </div>
  );
}
